"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountProvider = useAccountProvider;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_injectors_1 = require("../../utils/@reduxjs/redux-injectors");
const useAccountProviderSSE_1 = require("./hooks/useAccountProviderSSE");
const ConfigProvider_1 = require("../ConfigProvider");
const slice_1 = require("./slice");
const saga_1 = require("./saga");
const selectors_1 = require("./selectors");
/**
 * @param getEventSource: function that returns an EventSource instance for the given url and options.
 * It is required to pass it from the app to ensure, that we use specific implementation of EventSource
 * for browser and mobile applications
 */
function useAccountProvider({ getEventSource, reconnectOptions, }) {
    (0, redux_injectors_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, redux_injectors_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.accountProviderSaga });
    const accountId = (0, react_redux_1.useSelector)(selectors_1.selectAccountId);
    const dispatch = (0, react_redux_1.useDispatch)();
    const featureFlags = (0, react_redux_1.useSelector)(ConfigProvider_1.selectFeatureFlags);
    const virtualGamesProviderEnabled = featureFlags.VIRTUAL_GAMES_PROVIDER_ENABLED;
    (0, useAccountProviderSSE_1.useAccountProviderSSE)({ getEventSource, accountId, reconnectOptions });
    (0, react_1.useEffect)(() => {
        dispatch(slice_1.accountProviderActions.getUser({}));
    }, [dispatch]);
    (0, react_1.useEffect)(() => {
        // TODO it would be better to move this logic to accountProviderSaga
        if (accountId && !virtualGamesProviderEnabled) {
            // Obtaining Virtual Games tokens after account id is selected
            dispatch(slice_1.accountProviderActions.getBetGamesToken({
                accountId,
            }));
            dispatch(slice_1.accountProviderActions.getTurboGamesToken({
                accountId,
            }));
            dispatch(slice_1.accountProviderActions.getSportGamesToken({
                accountId,
            }));
            dispatch(slice_1.accountProviderActions.getLiveGamesToken({
                accountId,
            }));
            dispatch(slice_1.accountProviderActions.getTwainGamesToken({
                accountId,
            }));
            dispatch(slice_1.accountProviderActions.getCasinoToken({
                accountId,
            }));
            dispatch(slice_1.accountProviderActions.getCyberbetToken({ accountId }));
            dispatch(slice_1.accountProviderActions.getVsportToken({
                accountId,
            }));
            dispatch(slice_1.accountProviderActions.getFriggToken({ accountId }));
        }
    }, [dispatch, accountId]);
    (0, react_1.useEffect)(() => {
        if (accountId) {
            dispatch(slice_1.accountProviderActions.fetchLoyalty());
        }
    }, [accountId, dispatch]);
}
//# sourceMappingURL=useAccountProvider.js.map